export type Guests = {
  adults: any;
  children: any;
  ChildAges: number[];
  Quantity: number;
  NumAdults: number;
};

export type Root = {
  hotelId: number;
  checkInDate: string;
  numNights: number;
  guests: Guests;
};

export const getHotelSelectedData = () => {
  const hotelSelected = localStorage.getItem("hotelSelected");

  if (!hotelSelected) {
    return null;
  }

  return JSON.parse(hotelSelected) as Root;
};
